// src/components/ScrollProgress.jsx
import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { useLang } from '../context/LangContext';

const ScrollProgress = () => {
  const { isRtl } = useLang();
  const { scrollYProgress } = useScroll();

  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping  : 30,
    restDelta: 0.001,
  });

  return (
    <div className="lsq-scroll-track" aria-hidden>
      <motion.div
        style={{
          height         : '100%',
          background     : 'linear-gradient(to right, #8B3A3A, #D4AF37)',
          scaleX,
          transformOrigin: isRtl ? '100% 0' : '0% 0',
          boxShadow      : '0 0 10px rgba(212,175,55,0.4)',
          width          : '100%',
        }}
      />
    </div>
  );
};

export default ScrollProgress;
